export const GET_PARTNERS_REQUEST = 'GET_PARTNERS_REQUEST';
export const GET_PARTNERS_SUCCESS = 'GET_PARTNERS_SUCCESS';
export const GET_PARTNERS_FAILURE = 'GET_PARTNERS_FAILURE';

export const SAVE_PARTNER_REQUEST = 'SAVE_PARTNER_REQUEST';
export const SAVE_PARTNER_SUCCESS = 'SAVE_PARTNER_SUCCESS';
export const SAVE_PARTNER_FAILURE = 'SAVE_PARTNER_FAILURE';

export const SAVE_PARTNER_DETAILS_REQUEST = 'SAVE_PARTNER_DETAILS_REQUEST';
export const SAVE_PARTNER_DETAILS_SUCCESS = 'SAVE_PARTNER_DETAILS_SUCCESS';
export const SAVE_PARTNER_DETAILS_FAILURE = 'SAVE_PARTNER_DETAILS_FAILURE';

export const ADD_PARTNER_DETAILS_REQUEST = 'ADD_PARTNER_DETAILS_REQUEST';
export const ADD_PARTNER_DETAILS_SUCCESS = 'ADD_PARTNER_DETAILS_SUCCESS';
export const ADD_PARTNER_DETAILS_FAILURE = 'ADD_PARTNER_DETAILS_FAILURE';

export const ADD_EDITED_PARTNER = 'ADD_EDITED_PARTNER';
